import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const DEFAULT_CONFIG = {
  universidad_nombre: "Mi Universidad",
  facultad_label_singular: "Facultad",
  facultad_label_plural: "Facultades",
  unidad_label_singular: "Unidad Académica",
  unidad_label_plural: "Unidades Académicas",
  enable_unidades: true,
  alert_days: 90,
  accent_color: "#047857",
};

const ConfigContext = createContext({ config: DEFAULT_CONFIG, refresh: () => {} });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    // Skip fetching if no token (public pages: Landing, Login, Demo, Register)
    if (!localStorage.getItem("vinculo_token")) {
      setLoaded(true);
      return;
    }
    try {
      const { data } = await api.get("/config");
      setConfig({ ...DEFAULT_CONFIG, ...data });
    } catch {
      // keep defaults
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loaded, refresh: load, setConfig }}>
      {children}
    </ConfigContext.Provider>
  );
}

export const useConfig = () => useContext(ConfigContext);
